import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import Swal from 'sweetalert2'
import { environment } from 'src/environments/environment';
export const InterceptorSkipHeader = 'X-Skip-Interceptor';

@Injectable({
  providedIn: 'root'
})
export class ContratosInternosService {
  enviarTokenPost$ = new BehaviorSubject(null);
  enviarTokenAssinaturaLotePost$ = new BehaviorSubject(null);
  enviarQRCodePost$ = new BehaviorSubject(null);
  enviarCertificadoPost$ = new BehaviorSubject(null);
  responderTokenPost$ = new BehaviorSubject(null);
  responderTokenAssinaturaLotePost$ = new BehaviorSubject(null);
  fileGet$ = new BehaviorSubject(null);
  selecionarCertificadoGet$ = new BehaviorSubject(null);

  constructor(private http: HttpClient, private platformLocation: PlatformLocation) { }

  postEnviarToken(chave) {
    try {
      var obj: any = {
        id_autorizador_interno: environment.id_autorizador,
        empresa: environment.empresa,
        chave: chave
      }
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Contratos/EnviarTokenInterno/";
      var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
      headers.append('Content-Type', 'application/json');

      this.http.post(url, obj, { headers: headers })
        .subscribe({
          next: (res: any) => this.enviarTokenPost$.next(res),
          error: (error: HttpErrorResponse) => {
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.enviarTokenPost$.unsubscribe(),
            this.enviarTokenPost$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }


  postEnviarTokenAssinaturaLote(model) {
    try {
      var obj: any = {
        id_autorizador_interno: environment.id_autorizador,
        empresa: environment.empresa,
        identificadores : model,
        ip: model.ip,
        cd_usuario : model.cd_usuario
      }
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Contratos/GerarTokenAssinatura/";
      var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
      headers.append('Content-Type', 'application/json');

      this.http.post(url, obj, { headers: headers })
        .subscribe({
          next: (res: any) => this.enviarTokenAssinaturaLotePost$.next(res),
          error: (error: HttpErrorResponse) => {
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.enviarTokenAssinaturaLotePost$.unsubscribe(),
            this.enviarTokenAssinaturaLotePost$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }

  //Assinar Token
  postResponderToken(chave, token) {
    try {
      var obj: any = {
        id_autorizador_interno: environment.id_autorizador,
        empresa: environment.empresa,
        chave: chave,
        token: token
      }
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Contratos/AssinarInternoPorToken/";
      var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
      headers.append('Content-Type', 'application/json');

      this.http.post(url, obj, { headers: headers })
        .subscribe({
          next: (res: any) => this.responderTokenPost$.next(res),
          error: (error: HttpErrorResponse) => {
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.responderTokenPost$.unsubscribe(),
            this.responderTokenPost$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }

  postResponderTokenAssinaturaLote(model) {
    try {
      var obj: any = {
        id_autorizador_interno: environment.id_autorizador,
        empresa: environment.empresa,
        identificadores: model.identificadores,
        token: model.token
      }
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Contratos/AssinarToken/";
      var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
      headers.append('Content-Type', 'application/json');

      this.http.post(url, obj, { headers: headers })
        .subscribe({
          next: (res: any) => this.responderTokenAssinaturaLotePost$.next(res),
          error: (error: HttpErrorResponse) => {
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.responderTokenAssinaturaLotePost$.unsubscribe(),
            this.responderTokenAssinaturaLotePost$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }

  postEnviarQRCode() {
    try {
      var obj: any = {
        id_autorizador_interno: environment.id_autorizador,
        empresa: environment.empresa,
        chave: environment.token
      }
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Contratos/SolicitarQRCodeCliente/";
      var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
      headers.append('Content-Type', 'application/json');

      this.http.post(url, obj, { headers: headers })
        .subscribe({
          next: (res: any) => this.enviarQRCodePost$.next(res),
          error: (error: HttpErrorResponse) => {
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.enviarQRCodePost$.unsubscribe(),
            this.enviarQRCodePost$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }

  postEnviarCertificado(json) {
    try {
      var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
      headers.append('Content-Type', 'application/json');

      var url: string = environment.AdvFirmasWebApiCertificate + "AssinarCertificado/AssinarInternamentePorCertificado";

      this.http.post(url, json, { headers: headers }).subscribe({
        next: (data) => this.enviarCertificadoPost$.next(data),
        error: (error: HttpErrorResponse) => {
          this.enviarCertificadoPost$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.enviarCertificadoPost$.unsubscribe(),
          this.enviarCertificadoPost$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }

  public downloadFile(url_arquivo) {
    try {
      var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
      this.http.get(url_arquivo, { headers: headers }).subscribe({
        next: (data) => this.fileGet$.next(data),
        error: (error: HttpErrorResponse) => {
          this.fileGet$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.fileGet$.unsubscribe(),
          this.fileGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }

  getSelecioneCertificado() {
    try {
      var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
      var url: string = environment.AdvFirmasWebApiCertificate + "AssinarCertificado/SelecionaCertificado";

      this.http.get(url, { headers: headers }).subscribe({
        next: (data) => this.selecionarCertificadoGet$.next(data),
        error: (error: HttpErrorResponse) => {
          this.selecionarCertificadoGet$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.selecionarCertificadoGet$.unsubscribe(),
          this.selecionarCertificadoGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }
}
